import Layout from "../../components/shared/layout/layout";
import styles from "../../styles/pages/weinkauf/index.module.css"
import Collapsible from "../../components/collapsible/collapsible";
import Link from "next/link";
import Seo from "../../components/shared/seo/seo";


export default function BuyWine(){
    return (
        <Layout>
            <Seo
                title="Weinkauf"
                description="Weinkauf beim Weingut Gisperg — ab Hof, Lieferfahrt und B2B. Jetzt im Online-Shop bestellen."
                path="/weinkauf"
            />
            <section className="background_light_texture">
                <div className="col-6">
                    <h1 className="white">Weinkauf</h1>
                    <p className="brown robertson subtitle">Wein auf Reisen</p>
                    <p>Tauchen Sie ein in unser Sortiment. Bei einem persönlichen Besuch in unserem Weingut finden wir gemeinsam den passenden Wein für Ihren Geschmack und perfekten „Weinmoment“.  Über unseren Onlineshop können Sie außerdem auch jederzeit bequem von zuhause einkaufen.</p>
                    <div className="horizontal">
                        <div className="col-3">
                                <Link href="#abhof"><p className="white annotation marker link">Ab Hof</p></Link>
                        </div>
                        <div className="col-3">
                            <Link href="#lieferfahrt"><p className="white annotation marker link">Lieferfahrt</p></Link>
                        </div>
                        <div className="col-3">
                           <Link href="#b2b"><p className="white annotation marker link">B2B</p></Link>
                        </div>
                    </div>
                    <h2 className="size-40 uppercase">Online Shop</h2>
                    <Link href="/weinkauf/shop"><p className="button primary x2">Jetzt Shoppen</p></Link>
                </div>
            </section>
            <section className="background_light">
                <span  className="anchor" id="abhof" ></span>
                <div className="col-12">
                    <h2>Ab Hof</h2>
                </div>
                <div className="horizontal">
                    <div className="col-4 start">
                        <p>Für Ihren Weineinkauf sind wir von MO-FR 8-12|13-18 Uhr, SA auf Anfrage, ausgenommen Feiertage für Sie da. Benutzen Sie bitte die Glocke am Aufzug, wenn Sie beim Weingut sind, und warten Sie im Eingangsbereich.</p>
                    </div>
                    <div className="col-4 start">
                        <p>Sie wissen genau was Sie möchten? Vorab bestellen und die vorbereiteten Weine zu gewohnten Preis abholen. Dies ermöglicht uns, Wartezeiten so gering wie möglich zu halten. </p>
                    </div>
                </div>
                <div className="col-6">
                    <Collapsible id="1"
                                 title=" Bestellung"
                                 content='Wenn Sie per E-Mail an <a  class="underline" href="mailto:wein@weingut-gisperg.at">wein@weingut-gisperg.at</a>  oder während unserer Öffnungszeiten telefonisch unter <a  class="underline" href="tel:0225381464">02253/81464</a> oder einfach können Sie <a  class="underline" href="/prices">hier</a> unsere Preisliste anfragen.<br/>Bei Click & Collect Bestellungen im Onlineshop bitte "Abholung vor Ort anklicken" und im Anmerkungsfeld vor Bestellabschluss folgende Informationen vermerken:<br/><br/>- Abholdatum & ungefährer Abholzeit<br/>- Falls Sie Leergut retournieren, nach Möglichkeit die genaue Anzahl/Füllmenge'/>
                    <Collapsible id="2"
                                 title="Abholung"
                                 content='Benutzen Sie bitte die Glocke am Aufzug, wenn Sie beim Weingut sind, und warten Sie im Eingangsbereich. Ihre Bestellung wird zum gewünschten Zeitpunkt im Hof zum Mitnehmen bereitstehen, wenn Sie uns vorab Ihre Wein-Wünsche bekannt gegeben haben. '/>
                    <Collapsible id="3"
                                 title="Verkostung"
                                 content='Kleine Verkostungen sind während des Weinkaufes möglich. Bei mehreren Personen oder umfangreicheren Verkostungen bitte um Anfrage'/>
                    <Collapsible id="4"
                                 title=" Bezahlung"
                                 content='Bezahlung ist Bar oder mit Bankomatkarte möglich. Wenn Sie mit Bargeld zahlen wollen, teilen wir Ihnen gerne den Rechnungsbetrag mit.'/>
                    <hr size="1" width="100%"/>
                </div>
                <p className="button primary x2 uppercase"><Link href="/weinkauf/shop">Click & Collect</Link></p>
            </section>
            <div className="transition_div horizontal">
                <div className="col-4">
                    <p className="phrase white">Sie wollen Ihre Weine geliefert bekommen?</p>
                </div>
                <div className="col-4">
                    <p className="narrow white">Gerne schicken wir Ihnen unsere<br/> Weine via Paketdienst zu<br/> oder liefern sie persönlich.</p>
                </div>
                <div className="col-4">
                    <Link href="/weinkauf/shop"><p className="button secondary x3 dark">Zum Shop</p></Link>
                </div>
            </div>
            <section  className="background_lighter">
                <span  className="anchor" id="lieferfahrt" ></span>
                <div className="col-12">
                    <h2>Lieferfahrt</h2>
                    <p className="information brown">Zuverlässige und persönliche Lieferung</p>
                </div>
                <div className="col-6">
                    <p>Bereits seit vielen Jahren liefern wir persönlich und zuverlässig in Österreich und Bayern direkt zu unseren Kunden nach Hause. Wie das funktioniert und ob wir persönlich in Ihre Gegend liefern, erklären wir Ihnen gerne persönlich.<br/><br/> Sie möchten regelmäßig über Liefertermine in Ihre Gegend informiert werden? Im <Link
                        href="/kontakt/#formular"><span className="underline link">Anfrage-Formular</span></Link> können Sie sich jederzeit zu Informationen dazu an- oder abmelden. So funktioniert's:
                    </p>
                    <Collapsible id="5"
                                 title="Bestellung"
                                 content='Lieblingsweine einfach im <a  href="/weinkauf/shop" class="underline">Onlineshop</a> bestellen oder <a  href="/prices" class="underline">Preisliste anfragen</a> und Ihre Bestellung per E-Mail an <a  class="underline" href="mailto:wein@weingut-gisperg.at">wein@weingut-gisperg.at</a> oder telefonisch unter <a  href="tel:+43225381464">02253 81464</a> bekannt geben. Falls Sie Leergut retournieren, bitte bei der Bestellung die genaue Anzahl bekanntgeben. Gerne können Sie sich auch individuell zusammengestellte Verkostungspakete zum bequemen Degustieren zuhause bestellen.<br/><br/>

Voraussetzung für eine persönliche Lieferung ist eine Lieferadresse, bei der unter Tags angeliefert, abgegeben oder hinterlegt werden kann. Gerne besprechen wir die verschiedenen Möglichkeiten persönlich mit Ihnen. Bitte um Angabe einer unter der Sie am Liefertag für den Fahrer erreichbar sind, sollten Fragen auftauchen oder längere verkehrsbedingte Verzögerungen auftreten.<br/><br/>

Bitte beachten Sie unsere Verpackungsgrößen:<br/>
8er Karton:            Landwein<br/>
6er Karton:            Frizzante, Sekt, Reserven, Bouteillen, Traubensaft<br/>
12er Karton:           Bouteillen, Traubensaft<br/><br/>

Aus Sicherheits- & Transportgründen kann nur in den angegeben Verpackungen geliefert werden - gerne auch gemischte Weinpakete. Geschenkverpackungen für 1-3 Flaschen sind auf Anfrage erhältlich.

'/>
                    <Collapsible id="6"
                                 title="Liefertermin & Zustellung"
                                 content='Lieferintervalle sind vom Liefergebiet abhängig - je nachdem werden Liefertermine geplant und ausgeschrieben oder Bestellungen nach Nachfrage ausgeliefert. Welche Variante auf Ihre Gegend zutrifft, teilen wir Ihnen gerne persönlich mit. Sie können uns auch jederzeit Ihre Bestellung zusenden und wir informieren Sie individuell, wie eine für Sie geeignete Lieferung möglich ist.<br/><br/>

Nach erfolgter Routenplanung informieren wir Sie über einen genauen Liefertermin. Da wir unsere Lieferfahren so ökologisch und ökonomisch wie möglich planen, können Terminwünsche leider nur bedingt berücksichtigt werden (Paketversand ist jederzeit möglich). Wir liefern unsere Weine persönlich zum mitgeteilten Liefertermin - gerne auch kontaktlos.<br/><br/>

Eine Verbringung in Wohnungen oder Keller ist nur möglich, wenn ein Aufzug vorhanden ist. Leergut bitte nach Möglichkeit wieder in den herkunftalkartons verpacken und für die Retournierung vorbereiten. '/>
                    <Collapsible id="7"
                                 title="Bezahlung"
                                 content='Bezahlung ist Bar oder via Überweisung möglich. Wenn Sie mit Bargeld zahlen wollen, teilen wir Ihnen gerne den Betrag mit. Bankdaten für die sofortige Übeweisung finden Sie auf der Rechnung, welche Sie bei Lieferung vom Fahrer erhalten. Bitte um kurze Anmerkung falls Sie einen Zahlschein benötigen.  '/>
                    <hr size="1" width="100%"/>
                </div>
            </section>
            <div className="transition_div horizontal">
                <div className="col-4">
                    <p className="phrase white">Sie wollen nicht bist zur nächsten Lieferfahrt warten?</p>
                </div>
                <div className="col-4">
                    <p className="narrow white">Sie können sich jederzeit unsere<br/> Weine bei uns Ab-Hof abholen oder<br/> sich via Paketdienst schicken lassen.</p>
                </div>
                <div className="col-4">
                    <Link href="/weinkauf/shop"><p className="button secondary x3 dark">Zum Shop</p></Link>
                </div>
            </div>
            <section className="background_light">
                <span  className="anchor" id="b2b" ></span>
                <div className="col-6">
                    <h2>B2B</h2>
                    <p>Sie sind Wiederverkäufer|In, Gastronom|In oder Firmenkunde|In und interessiert an einer Zusammenarbeit?<br/><br/>
                        Wir beraten Sie persönlich bei der Erweiterung Ihres Sortiments, ob Sie die Weine direkt oder von einem unserer Partner|Innen beziehen, über optimale Foodpaarings für Ihr nächstes Menü, personalisierte Weihnachtsgeschenke für Ihre Kunden|Innen & Mitarbeiter|Innen und noch vieles mehr. Treten Sie mit uns direkt oder über unser Kontaktformular in Verbindung. Wir freuen uns darauf Sie kennenzulernen. </p>
                    <p className="phrase brown">Jetzt gemeinsam<br/> Momente schaffen</p>
                </div>
                <div className="horizontal">
                    <div className="col-6 right">
                       <Link href="/kontakt/#formular"><p className="button primary x2">Formular</p></Link>
                    </div>
                    <div className="col-6 left">
                        <p className="button secondary x2">V-Card</p>
                    </div>
                </div>
            </section>
        </Layout>
    );
}